import React from 'react';

//CORE COMPONENTS
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';
import styled from 'styled-components';

import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerVerticalAlignment,
    ContainerHorizontalAlignment,
    ContainerGutter,
} from '../../../components-core/packages/components-core/dist/container/index';
import {  Layout } from '../../../components-core/packages/components-core/dist/layout/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { 
    Text, 
    TextAppearance, 
    TextAlignment,
} from '../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Image } from '../../../components-core/packages/components-core/dist/image/index';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper/index';
import { Button, ButtonAppearance} from '../../../components-core/packages/components-core/dist/button/index';

//ICONS CORE
import { ChevronLeft } from '../../../components-core/packages/icons-core/dist/ChevronLeft/index';
import { ChevronRight } from '../../../components-core/packages/icons-core/dist/ChevronRight/index';
import { Checkmark } from '../../../components-core/packages/icons-core/dist/Checkmark/index';

//3RD PARTY
import Slider from "react-slick";


//renderTitle
const TopContainer = styled.div`
    widht: 100vw;
`;

const Line = styled.div`
    width: 100%;
    height: 1px;
    background-color: #E2E7EA;

    margin-top: -2px;
`;

const SelectedLine = styled.div`
    width: 100%;
    height: 2px;
    background-color: #00437a;
    display: ${props => props.isSelected ? 'block' : 'none'};
`;


//renderDescription
const DescriptionContainer = styled.div`
`;

const ColorContainer = styled.div`
    background-color: ${props => props.backgroundColor};
    min-height: 160px;
    width: 100%;
    padding-top: 24px;
`;

const ImageContainer = styled.div`
    margin: -30% auto 0 auto;
`;

const CustomButton = styled.div`
    opacity: ${props => props.isSelected ? '1' : '0.4'};
    cursor: pointer;
`;

const ArrowButton = styled(CustomButton)`
    opacity: ${props => props.opacity};
`;


class ModelSlider extends React.Component {

    constructor() {
        super();
        this.state = {
            selectedIndex: 0,
            itemsLength: 0
        }
    }

    renderTitle(index) {
        const items = listItems(this.props);

        const isSelected = this.state.selectedIndex === index;

        if (!items[index].title) {
            return;
        }

        return (
            <BreakpointWrapper min={breakpointList[index]} >
                <CustomButton 
                    onClick={() => this.setState({selectedIndex: index})}
                    isSelected={isSelected}
                >
                    <Container 
                        wrap={ContainerWrap.always} 
                        padding={{ top: ContainerPadding.dynamic0050, bottom: ContainerPadding.dynamic0050 }} 
                    >
                        <Text 
                            textAlign={TextAlignment.center} 
                            appearance={TextAppearance.headline0250}
                            bold={true}
                        >
                            {items[index].title} 
                        </Text>
                        <Text 
                            textAlign={TextAlignment.center} 
                            appearance={TextAppearance.copy0150} 
                        >
                            <Text bold>{items[index].price}</Text>
                            'den başlayan fiyatlarla
                        </Text>
                    </Container>            
                </CustomButton>
                <SelectedLine isSelected={isSelected}/>
            </BreakpointWrapper> 
        )
    }

    renderTitleContainer() {
        const items = listItems(this.props);

        const renderedTitles = items.map(
            (item, index) => this.renderTitle(index)
        )

        return (
            <Container wrap={ContainerWrap.never} gutter={ContainerGutter.dynamic0200}>
                {renderedTitles}
            </Container>
        )
    }

    renderDescriptionsLeft(index) {
        const items = listItems(this.props);

        return (    
            <DescriptionContainer >
                <ColorContainer  backgroundColor={items[index].color} />
                <ImageContainer>
                    <Image 
                        src={items[index].photo}
                        alt={items[index].title}
                    />
                </ImageContainer>
            </DescriptionContainer>
        )
    }

    renderListItem() {
        const items = listItems(this.props);
        const options = items[this.state.selectedIndex].whybuy.split('-')
        
        const renderedItems = options.map(item => 
            <Container 
                wrap={ContainerWrap.never} 
                gutter={ContainerGutter.static200} 
                verticalAlign={ContainerVerticalAlignment.center}
            >
                <Checkmark variant={'small'} />
                <Text appearance={TextAppearance.copy0150}>{item}</Text>
            </Container>
        )
        
        return (
            <Container wrap={ContainerWrap.always} gutter={ContainerGutter.static150}>
                {renderedItems}
            </Container>
        )
    }

    renderDescriptionsRight(index) {
        const items = listItems(this.props);
        
        return (
            <Container 
                stretchContent={true} 
                wrap={ContainerWrap.always} 
                gutter={ContainerGutter.dynamic0100}
                padding={descriptionsRightPadding} 
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <Text appearance={TextAppearance.copy0150} >
                    {items[index].description ? items[index].description : ' '}
                </Text>  
                {this.renderListItem()}
                <Button 
                    appearance={ButtonAppearance.Primary} 
                    stretchContent={typeof window !== 'undefined' && window.innerWidth <= 560 ? true : false}
                >
                    Modeli incele
                </Button>
            </Container>
        )
    }

    renderSlider() {
        const items = listItems(this.props);

        const renderedItems = items.map((item, index) => item.title &&
            <Container 
                wrap={ContainerWrap.always} 
                padding={{ 
                    top: ContainerPadding.dynamic0100,
                    left: ContainerPadding.dynamic0050,
                    right: ContainerPadding.dynamic0050
                }} 
            >
                {this.renderDescriptionsLeft(index)}
                {this.renderDescriptionsRight(index)}
            </Container> 
        )
        
        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: "30px",
            beforeChange: (current, next) => 
                this.setState({ selectedIndex: next }),
        };

        return (
            <Slider ref={slider => (this.slider = slider)} {...settings}>
                {renderedItems}
            </Slider>
        )  
    }

    renderDetails() {
        return (
            <Container 
                stretchContent={true} 
                padding={detailsPadding} 
            >
                <Layout appearance={detailsLayoutBreakpoints} >
                    {this.renderDescriptionsLeft(this.state.selectedIndex)}
                    {this.renderDescriptionsRight(this.state.selectedIndex)}
                </Layout>
            </Container>
        )
    }

    onRightArrowClick(selectedIndex) {
        const items = listItems(this.props);
        let counter = 0;
        items.forEach(item => {
            if (item.title) {
                counter++;
            }
        })

        this.setState({ itemsLength: counter - 1});


        if (selectedIndex < counter -1 ) {
            this.setState({ selectedIndex: selectedIndex + 1 })
            this.slider.slickGoTo(selectedIndex + 1)
        }
    }

    onLeftArrowClick(selectedIndex) {
        if (selectedIndex > 0) {
            this.setState({ selectedIndex: selectedIndex - 1 })
            this.slider.slickGoTo(selectedIndex - 1)
        }
    }

    render() {
        const items = listItems(this.props);

        const selectedIndex = this.state.selectedIndex;

        const renderedChevronLeft = (
            <BreakpointWrapper max={Breakpoints.b1280} >
                <ArrowButton 
                    opacity={selectedIndex === 0 ? 0.4 : 1} 
                    onClick={() => this.onLeftArrowClick(selectedIndex)} 
                >
                    <ChevronLeft />
                </ArrowButton>
            </BreakpointWrapper>
        )

        const renderedChevronRight = (
            <BreakpointWrapper max={Breakpoints.b1280} >
                <ArrowButton 
                    opacity={selectedIndex === this.state.itemsLength ? 0.4 : 1} 
                    onClick={() => this.onRightArrowClick(selectedIndex)}
                >
                    <ChevronRight />
                </ArrowButton>
            </BreakpointWrapper>
        )

        return (
                <ThemeProvider>
                    <Container 
                        stretchContent={true} 
                        padding={{ left: desktopPadding, right: desktopPadding }}
                    >
                        <TopContainer>
                            <Container 
                                wrap={ContainerWrap.never} 
                                verticalAlign={ContainerVerticalAlignment.center}
                                horizontalAlign={ContainerHorizontalAlignment.spaceBetween}
                                padding={{ left: mobilePadding, right: mobilePadding }} 
                            >
                                {renderedChevronLeft}
                                <BreakpointWrapper min={Breakpoints.tablet}>
                                    {this.renderTitleContainer()}
                                </BreakpointWrapper>
                                <BreakpointWrapper max={Breakpoints.tablet}>
                                    {this.renderTitle(this.state.selectedIndex)}
                                </BreakpointWrapper>
                                {renderedChevronRight}                                
                            </Container>

                            <Line />

                            <BreakpointWrapper min={Breakpoints.b560} >
                                {this.renderDetails()}
                            </BreakpointWrapper>
                            
                            <BreakpointWrapper max={Breakpoints.b560}>
                                {this.renderSlider()}
                            </BreakpointWrapper>

                        </TopContainer>
                    </Container>
                </ThemeProvider>
        )
    }
}

const listItems = (props) => [
    {
        title: props.custom,
        description: props.custom5,
        price: props.custom15,
        photo: props.custom20,
        color: props.custom10,
        whybuy: props.custom25
    },
    {
        title: props.custom1,
        description: props.custom6,
        price: props.custom16,
        photo: props.custom21,
        color: props.custom11,
        whybuy: props.custom26
    },
    {
        title: props.custom2,
        description: props.custom7,
        price: props.custom17,
        photo: props.custom22,
        color: props.custom12,
        whybuy: props.custom27
    },
    {
        title: props.custom3,
        description: props.custom8,
        price: props.custom18,
        photo: props.custom23,
        color: props.custom13,
        whybuy: props.custom28
    },
    {
        title: props.custom4,
        description: props.custom9,
        price: props.custom19,
        photo: props.custom24,
        color: props.custom14,
        whybuy: props.custom29
    },
]

const optionsList = [
    'Çift reflektörlü halojen farlar',
    'Klimatronik klima',
    'Hız sabitleyici',
    'Alüminyum alaşımlı jant',
    'Karartılmış arka cam'
]

const breakpointList = [
    Breakpoints.default,
    Breakpoints.b560,
    Breakpoints.b960,
]

const mobilePadding = { 
    [Breakpoints.default]: ContainerPadding.grid001,
    [Breakpoints.b1280]: null 
}

const desktopPadding = {
    [Breakpoints.b1280]: ContainerPadding.grid002
}

const detailsPadding = {
    top: ContainerPadding.dynamic0100,
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b1280]: null
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b1280]: null
    }
}

const descriptionsRightPadding = {
    left: { 
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: ContainerPadding.dynamic0100 
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b560]: null
    }
}

const detailsLayoutBreakpoints = {
    [Breakpoints.default]: [
        {name: 'a', columns: 24},
        {name: 'b', columns: 24}
    ],
    [Breakpoints.b560]: [
        {name: 'a', columns: 12},
        {name: 'b', columns: 12}
    ]
}

export default ModelSlider;